import entryMixin from '@/assets/mixins/entry';
import langs from '@/assets/locale/lang/rush-answer';
import { BEFORE_DESTROY } from '@/assets/utils/compat';

export default {
  langs,
  mixins: [entryMixin],
  props: {
    rushAnswerSdk: {
      type: Object,
      default: null,
    },
  },
  watch: {
    rushAnswerSdk: {
      immediate: true,
      async handler(nv) {
        if (nv) {
          this.startHandler = this.onStart.bind(this);
          this.stopHandler = this.onStop.bind(this);
          this.remainingNumberChange = this.onRemaining.bind(this);
          this.bindAppEvents();
        }
      },
    },
    visible(nv) {
      this.showTimestamp = nv ? Date.now() : -1;
      this.$emit('visible-changed', nv);
    },
    entranceVisible(nv) {
      this.$emit('entry-visible-changed', nv);
    },
  },
  data() {
    return {
      // 剩余时间
      overTime: 0,
      // 剩余人数
      remainingNumber: 0,
      // 当前抢答ID
      quicklyId: undefined,
      // 查询抢答状态定时器
      statusTimer: null,
      // 剩余时间倒计时定时器
      pollingOverTimer: null,
      // 是否正在抢答(没抢答、已结束或者已抢答)
      inRushAnswer: false,
      // 抢答弹窗显示的本地时间戳
      showTimestamp: -1,
      // 是否抢答成功
      answerStatus: false,
      // 显示抢答弹窗
      visible: false,
      // 显示入口
      entranceVisible: false,
      // 是否为富德
      isFuDe: false,
    };
  },
  [BEFORE_DESTROY]() {
    this.unbindAppEvents();
    this.clear();
    this.stopPolling();
  },
  methods: {
    _getCoreSdk() {
      return this.rushAnswerSdk;
    },
    bindAppEvents() {
      const rushAnswerSdk = this.rushAnswerSdk;
      if (!rushAnswerSdk) { return; }
      rushAnswerSdk.on(rushAnswerSdk.events.GET_ANSWER_QUICKLY_STATUS, this.updateStatus);
      rushAnswerSdk.on(rushAnswerSdk.events.START_ANSWER_QUICKLY, this.startHandler);
      rushAnswerSdk.on(rushAnswerSdk.events.STOP_ANSWER_QUICKLY, this.stopHandler);
      rushAnswerSdk.on(rushAnswerSdk.events.ANSWER_QUICKLY_REMAINING, this.remainingNumberChange);
    },
    unbindAppEvents() {
      const rushAnswerSdk = this.rushAnswerSdk;
      if (!rushAnswerSdk) { return; }
      rushAnswerSdk.off(rushAnswerSdk.events.GET_ANSWER_QUICKLY_STATUS, this.updateStatus);
      rushAnswerSdk.off(rushAnswerSdk.events.START_ANSWER_QUICKLY, this.startHandler);
      rushAnswerSdk.off(rushAnswerSdk.events.STOP_ANSWER_QUICKLY, this.stopHandler);
      rushAnswerSdk.off(rushAnswerSdk.events.ANSWER_QUICKLY_REMAINING, this.remainingNumberChange);
    },
    onStart(msg) {
      // TODO:富德抢答没有maxNumber，不显示
      this.isFuDe = !msg.maxNumber;
      if (this.isFuDe) return;
      this.quicklyId = msg.quicklyId;
      this.overTime = msg.overTime;
      this.remainingNumber = msg.maxNumber;
      this.inRushAnswer = true;
      this.answerStatus = false;
      this.entranceVisible = true;
      this.visible = true;
      this.polling();
    },
    onStop() {
      if (this.isFuDe) return;
      this.inRushAnswer = false;
      this.entranceVisible = false;
      this.visible = true;
      this.clear();
      this.stopPolling();
    },
    onRemaining(msg) {
      if (!this.inRushAnswer) return;
      this.remainingNumber = msg.remainingNumber;
    },
    async updateStatus(data) {
      // TODO:富德抢答没有maxNumber，不显示
      this.isFuDe = !data.maxNumber;
      if (this.isFuDe) return;
      this.inRushAnswer = true;
      this.visible = true;
      this.answerStatus = false;
      this.entranceVisible = true;
      this.overTime = data.overTime;
      this.remainingNumber = data.maxNumber - data.answerNum;
      this.polling();
    },
    clear() {
      clearTimeout(this.statusTimer);
      this.statusTimer = null;
    },
    polling() {
      this.stopPolling();
      this.pollingOverTimer = setInterval(() => {
        if (this.overTime > 0) {
          this.overTime -= 1;
        }
      }, 1000);
    },
    stopPolling() {
      clearTimeout(this.pollingOverTimer);
      this.pollingOverTimer = null;
    },
    async submit() {
      try {
        const data = await this.rushAnswerSdk.submit(this.quicklyId, (Date.now() - this.showTimestamp) / 1000);
        this.answerStatus = data.status === 'success';
        this.inRushAnswer = false;
        this.entranceVisible = false;
        this.clear();
        this.stopPolling();
      } catch (error) {
        console.warn(error);
      }
    },

    close() {
      this.visible = false;
    },

    clickEntrance() {
      this.visible = true;
    },
  },
};
